import {ConstantAaDomainEntity} from 'antibodies/nested-data-creation/constants/AntibodyNestedDataCreationConstants';
import {DefinedConstantDomainEntity} from 'antibodies/nested-data-creation/NestedDataCreationDAO';

/**
 * Returns true if every constant domain has an AA sequence ID specified
 */
export function areConstantDomainsFullyDefined(
  constantDomains: Array<ConstantAaDomainEntity>
): constantDomains is Array<DefinedConstantDomainEntity> {
  return constantDomains.every((domain) => domain.aaSequenceId != null);
}
